import {
  EValue,
  ISortTypeTermFieldSchema,
} from '../../repositories/newbuilding-promos/entities/json_query/SortTypeTermFieldSchema';
import { ESortVariants, IJsonQuerySortType } from '../../types/jsonQuery/sortType';
import { EJsonQueryType } from '../../types/jsonQuery/term';

const SORT_VARIANTS_MAP = new Map([
  [EValue.NewFirst, ESortVariants.NewFirst],
  [EValue.Popularity, ESortVariants.Popularity],
  [EValue.AboutToEnd, ESortVariants.AboutToEnd],
]);

export function mapSort(term?: ISortTypeTermFieldSchema | null): IJsonQuerySortType | null {
  if (!term) {
    return null;
  }

  return {
    type: EJsonQueryType.Term,
    value: SORT_VARIANTS_MAP.get(term.value) as ESortVariants,
  };
}
